export const navDesktopHeight = 4.0;
export const navMobileHeight = 4.0;
export const navLogoDesktopHeight = 2.4;
export const navLogoMobileHeight = 2.4;
